import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import doctor_img from "../../assests/img/Health-Advisor.webp";
import twitter from "../../assests/img/twitter-footer.webp";
import facebook from "../../assests/img/facebook-footer.webp";
import InstagramIcon from "@mui/icons-material/Instagram";
import youtube from "../../assests/img/youtube-footer.webp";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <div className="coustom_container">
        {/* <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Popular Tests</Accordion.Header>
                        <Accordion.Body>
                            Pregnancy Test <span>|</span>
                            Full Body Checkups <span>|</span>
                            Covid 19 Test <span>|</span>
                            Heart Test <span>|</span>
                            Kidney Test <span>|</span>
                            Liver Test <span>|</span>
                            CBC Test <span>|</span>
                            Cholesterol Test <span>|</span>
                            HbA1c Test <span>|</span>
                            Hepatitis B Test <span>|</span>
                            Kidney Function Test <span>|</span>
                            Liver Function Test <span>|</span>
                            Sugar Test <span>|</span>
                            Thyroid Test <span>|</span>
                            Typhoid Test <span>|</span>
                            Uric Acid Test <span>|</span>
                            Vitamin B12 Test <span>|</span>
                            Vitamin D Test <span>|</span>
                            Allergy Test <span>|</span>
                            Arthritis Test <span>|</span>
                            Cancer Test <span>|</span>
                            Bone And Joint <span>|</span>
                            Dengue Test <span>|</span>
                            Diabetes Test <span>|</span>
                            Rheumatoid Test <span>|</span>
                            Tuberculosis Test <span>|</span>
                            Infertility Test <span>|</span>
                            Diabetes Care <span>|</span>
                            Anemia Test <span>|</span>
                            GastroIntestinal <span>|</span>
                            Autoimmune Disorders <span>|</span>
                            Fever Test
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Lab Test At Home</Accordion.Header>
                        <Accordion.Body>
                            Agartala <span>|</span>
                            Agra <span>|</span>
                            Ahmedabad <span>|</span>
                            Aligarh <span>|</span>
                            Allahabad <span>|</span>
                            Alwar <span>|</span>
                            Ambala <span>|</span>
                            Amravati <span>|</span>
                            Amritsar <span>|</span>
                            Aurangabad <span>|</span>
                            Azamgarh <span>|</span>
                            Bahadurgarh <span>|</span>
                            Bareilly <span>|</span>
                            Begusarai <span>|</span>
                            Bengaluru <span>|</span>
                            Bhatinda <span>|</span>
                            Bhilai <span>|</span>
                            Bhopal <span>|</span>
                            Bhubaneshwar <span>|</span>
                            Bijnor <span>|</span>
                            Bilaspur <span>|</span>
                            Chandigarh <span>|</span>
                            Chennai <span>|</span>
                            Coimbatore <span>|</span>
                            Daltonganj <span>|</span>
                            Darbhanga <span>|</span>
                            Dehradun <span>|</span>
                            Delhi <span>|</span>
                            Deoria <span>|</span>
                            Dhanbad <span>|</span>
                            Durgapur <span>|</span>
                            Faridabad <span>|</span>
                            Faizabad <span>|</span>
                            Gaya <span>|</span>
                            Ghaziabad <span>|</span>
                            Goa Velha <span>|</span>
                            Gorakhpur <span>|</span>
                            Greater Noida <span>|</span>
                            Gurgaon <span>|</span>
                            Guwahati <span>|</span>
                            Gwalior <span>|</span>
                            Haldwani <span>|</span>
                            Haridwar <span>|</span>
                            Hisar <span>|</span>
                            Hoshiarpur <span>|</span>
                            Howrah <span>|</span>
                            Hyderabad <span>|</span>
                            Indore <span>|</span>
                            Jabalpur <span>|</span>
                            Jaipur <span>|</span>
                            Jalandhar <span>|</span>
                            Jammu <span>|</span>
                            Jamshedpur <span>|</span>
                            Jodhpur <span>|</span>
                            Kangra <span>|</span>
                            Kanpur <span>|</span>
                            Karnal <span>|</span>
                            Khanna <span>|</span>
                            Kochi <span>|</span>
                            Kolkata <span>|</span>
                            Kota <span>|</span>
                            Kurukshetra <span>|</span>
                            Lucknow <span>|</span>
                            Ludhiana <span>|</span>
                            Mangalore <span>|</span>
                            Mathura <span>|</span>
                            Meerut <span>|</span>
                            Modinagar <span>|</span>
                            Moga <span>|</span>
                            Mohali <span>|</span>
                            Moradabad <span>|</span>
                            Mumbai <span>|</span>
                            Muzaffarpur <span>|</span>
                            Mysore <span>|</span>
                            Nagpur <span>|</span>
                            Nashik <span>|</span>
                            Noida <span>|</span>
                            Panchkula <span>|</span>
                            Panipat <span>|</span>
                            Pathankot <span>|</span>
                            Patiala <span>|</span>
                            Patna <span>|</span>
                            Pune <span>|</span>
                            Purnia <span>|</span>
                            Raipur <span>|</span>
                            Ranchi <span>|</span>
                            Rewari <span>|</span>
                            Rohtak <span>|</span>
                            Sagar <span>|</span>
                            Saharanpur <span>|</span>
                            Shillong <span>|</span>
                            Shimla <span>|</span>
                            Silchar <span>|</span>
                            Siliguri <span>|</span>
                            Sirsa <span>|</span>
                            Sonipat <span>|</span>
                            Srinagar <span>|</span>
                            Udaipur <span>|</span>
                            Vadodara <span>|</span>
                            Varanasi <span>|</span>
                            Yamuna Nagar
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion> */}

        {/* <div className="feedback_banner_bg">
          <Row>
            <Col lg={4} md={4} sm={12} className="feedback_banner_img_text">
              <img src={doctor_img} alt="Doctors" />
            </Col>
            <Col lg={8} md={8} sm={12} className="feedback_banner_img_text">
              <div className="flex_column">
                <p>
                  Get a call back within 15 minutes from our Health Advisor for
                  Test Booking Assistance
                </p>
                <div className="input_position">
                  <input
                    type="text"
                    placeholder="Enter Your 10 Digit Mobile Number"
                  />
                  <span>📞</span>
                  <Button>Get a Callback</Button>
                </div>
              </div>
            </Col>
          </Row>
        </div> */}

        {/* <div className="footer_bottom">
          <Row>
            <Col lg={3} md={3} sm={12}>
              <div className="footer_bottom_content">
                <p className="font-bold">PATIENTS</p>
                <ul>
                  <li>Book A Test</li>
                  <li>Nearest Centre</li>
                  <li>Download Report</li>
                  <li>Download App</li>
                </ul>
              </div>
            </Col>
            <Col lg={3} md={3} sm={12}>
              <div className="footer_bottom_content">
                <p className="font-bold">DOCTORS</p>
                <ul>
                  <li>Test Menu</li>
                  <li>Our Labs</li>
                  <li>Events</li>
                  <li>Quality</li>
                </ul>
              </div>
            </Col>
            <Col lg={3} md={3} sm={12}>
              <div className="footer_bottom_content">
                <p className="font-bold">BUSINESS PARTNERSHIP</p>
                <ul>
                  <li>Partner With Us</li>
                  <li>Become A Vendor</li>
                  <li>Corporate Tie-up</li>
                  <li>International Partnership</li>
                </ul>
              </div>
            </Col>
            <Col lg={3} md={3} sm={12}>
              <div className="footer_bottom_content">
                <p className="font-bold">ABOUT US</p>
                <ul>
                  <li>Our Journey</li>
                  <li>Vision Mission & Values</li>
                  <li>Our Team</li>
                  <li>Our Network</li>
                </ul>
              </div>
            </Col>
          </Row>
        </div> */}
      </div>
      <div className="footer_bottom_bg">
        <div className="coustom_container">
          <p>2026 © kiorhealthcare8b@gmail.com </p>
          <p>
            <Link
              to="/terms-of-use"
              style={{ color: "#fff" }}
              id="top"
              onClick={() => {
                document.getElementById("top").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
            >
              Terms of Use |{" "}
            </Link>

            <Link
              to="/privacy-policy"
              style={{ color: "#fff" }}
              id="top"
              onClick={() => {
                document.getElementById("top").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
            >
              Privacy Policy
            </Link>
          </p>
          <div className="social_text_img">
            <p className="mb-0">Follow us on : </p>
            <div className="social_icon">
              <Link
                to="https://x.com/kiorhealthcare?t=HiUJr5cFb41Re3UMhgo--Q&s=09"
                target="_blank"
              >
                <img src={twitter} alt="Twitter" />
              </Link>
              <Link
                to="https://www.facebook.com/share/16cr3CsH83/"
                target="_blank"
              >
                <img src={facebook} alt="facebook" />
              </Link>
              <Link
                to="https://youtube.com/@kiorhealthcare-u9t?si=iK6kVmHIlx9Vv2PD"
                target="_blank"
              >
                <img src={youtube} alt="youtube" />
              </Link>
              <Link
                to="https://www.instagram.com/kior_healthcare?igsh=Zjl5Zm91cXJwZGU1"
                target="_blank"
              >
                <InstagramIcon />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
